var AddedOutcomesModifier = /** @class */ (function () {
    function AddedOutcomesModifier(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }
    AddedOutcomesModifier.prototype.modify = function (content) {
        if (content.outcomes === undefined || content.outcomes.add === undefined) {
            return;
        }
        var outcomes = content.outcomes.add;
        for (var i = 0; i < outcomes.length; i++) {
            var outcome = outcomes[i];
            var key = this._modelKeyRepository.addOutcome(outcome.e, outcome.id);
            outcomes[i] = Object.assign({
                type: outcome.t,
                condition: outcome.c,
                conditionTwo: outcome.c2,
                conditionThree: outcome.c3,
                playerId: outcome.p,
                playerName: outcome.pn,
                teamOne: outcome.t1,
                teamTwo: outcome.t2,
            }, key);
        }
    };
    return AddedOutcomesModifier;
}());
export default AddedOutcomesModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/AddedOutcomesModifier.js